module.exports = __webpack_public_path__ + "img/realtime-record.868f6909.png";